// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"61386133","608":"871f3409"}[chunkId] + ".chunk.js";
};